<template>
  <div class="caseList">
    <el-timeline :reverse="reverse">
      <el-timeline-item
        :color="color"
        v-for="(value, index) in caseTimeData"
        :key="index"
      >
      <p class="timeLine">{{ index }}</p>
      <ul>
        <li class="infoLi" v-for="(item, index1) in value" :key="item.pmid+'-'+index1" v-loading="item.loading">
          <h3>
            <span>{{ !item.translate ? item.title_en : item.title_cn }}</span>
            <!-- <img src="../../assets/img/ppt.png" alt=""> -->
            <em v-if="item.impact_factor">
              <img src="../../assets/img/icon6.png" alt="" class="L" />影响因子：{{ item.impact_factor }}
            </em>
          </h3>
          <div class="important-message">
            <span class="qikan"><em>期刊：</em>{{ item.journal_name }}</span>
            <span><em>PMID：</em>{{ item.pmid }}</span>
            <span><em>发表时间：</em>{{ item.pubdate }}</span>
          </div>
          <div class="userInfo">
            <el-avatar :size="48" :src="item.avatar"></el-avatar>
            <p class="info-box">
              <span><em class="pat-code">患者编号：</em>{{ item.patient_uid }}</span>
              <span class="gender">{{ item.gender ? '男' : '女' }} {{ item.age }}岁</span>
            </p>
          </div>
          <div class="listInfo">
            <!-- 疾病与人群 -->
            <p class="info-detail" v-if="item.keywords && item.keywords['Diseases & conditions'].length > 0">
              <span>疾病与人群：</span>
              <template v-if="!item.translate">
                <em v-for="(words, wordsIndex) in item.keywords['Diseases & conditions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_en}${wordsIndex < item.keywords['Diseases & conditions'].length - 1 ? '、' : ''}` }} </em>
              </template>
              <template v-if="item.translate">
                <em v-for="(words, wordsIndex) in item.keywords['Diseases & conditions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_cn}${wordsIndex < item.keywords['Diseases & conditions'].length - 1 ? '、' : ''}` }} </em>
              </template>
            </p>
            <!-- 干预与操作 -->
            <p class="info-detail" v-if="item.keywords && item.keywords['Interventions'].length > 0">
              <span>干预与操作：</span>
              <template v-if="!item.translate">
                <em v-for="(words, wordsIndex) in item.keywords['Interventions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_en}${wordsIndex < item.keywords['Interventions'].length - 1 ? '、' : ''}` }} </em>
              </template>
              <template v-if="item.translate">
                <em v-for="(words, wordsIndex) in item.keywords['Interventions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_cn}${wordsIndex < item.keywords['Interventions'].length - 1 ? '、' : ''}` }} </em>
              </template>
            </p>
            <!-- 国家与地区 -->
            <p class="info-detail" v-if="item.keywords && item.keywords['Geographical regions'].length > 0">
              <span>国家与地区：</span>
              <template v-if="!item.translate">
                <em v-for="(words, wordsIndex) in item.keywords['Geographical regions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_en}${wordsIndex < item.keywords['Geographical regions'].length - 1 ? '、' : ''}` }} </em>
              </template>
              <template v-if="item.translate">
                <em v-for="(words, wordsIndex) in item.keywords['Geographical regions']" :key="words + '-' + wordsIndex">{{ `${words.keyword_cn}${wordsIndex < item.keywords['Geographical regions'].length - 1 ? '、' : ''}` }} </em>
              </template>
            </p>
            <p class="info-detail" :class="item.key_height">
              <span>疾病介绍：</span><em v-html="!item.translate ? item.patient_en : item.patient_cn"></em>
            </p>
            <p
              class="down"
              :class="item.key_height === 'initHeight' ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
              @click="showFull(item.key_height, index, index1)"
            ></p>
          </div>
          <div class="actionBox">
            <a href="javascript:;"
              @click="translateFullText(index, index1)">
              <img src="../../assets/img/icon14.png" alt="">翻译
            </a>
            <a href="javascript:;"
              @click="showCaseDetail(item)">
              <img src="../../assets/img/icon15.png" alt="">
              查看详情
            </a>
            <a href="javascript:;"
              @click="collection(item, index, index1)">
              <img src="../../assets/img/icon3-2.png" alt="" v-if="!item.is_collected">
              <img src="../../assets/img/icon3-3.png" alt="" v-if="item.is_collected">
              {{ item.is_collected ? '已收藏' : '收藏' }}
            </a>
            <a href="javascript:;" @click="showFullText(item)"><img src="../../assets/img/icon8-2.png" alt="">源文献</a>
            <a href="javascript:;" @click="showSimilarCase(item)"><img src="../../assets/img/icon9-2.png" alt="">相似病例</a>
          </div>
        </li>
      </ul>
      </el-timeline-item>
    </el-timeline>
    <el-pagination
      v-show="isCaseShow"
      background
      :hide-on-single-page="true"
      :current-page="pageNum"
      :page-size="pageSize"
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      :total="totalNum"
    >
    </el-pagination>
  </div>
</template>

<script>
  import { md5 } from "md5js";
  import { caseCollect, caseTranslate, translateInfo } from "../../service/getData";
  import { webTrackerEvent } from "../../utils/tracker";
  export default {
    data() {
      return{
        reverse: false,
        isCaseShow: true,
        totalNum: 0,
        pageSize: 10,
        pageNum: 1,
        caseData: [],
        caseTimeData: {},
        color: "#6a9edd",
        token: window.localStorage.getItem("PUBMEDSEARCHTOKEN"),
        openid: window.localStorage.getItem("PUBMEDSEARCHOPENID"),
      }
    },
    methods: {
      // 分页
      handleCurrentChange(val) {
        this.pageNum = val;
        window.scroll(0, 0);
        this.getCollection();
      },
      // 翻译重点信息
      async translateFullText(index, index1) {
        let currentData = this.caseTimeData[index];
        const { patient_uid, pmid, patient_cn, title_cn } = currentData[index1];
        if (currentData[index1].translate) {
          currentData[index1].translate = false
        } else {
          if(patient_cn && title_cn) {
            currentData[index1].translate = true
          } else {
            currentData[index1].loading = true;
            // 翻译patient_cn
            const params1 = {
              patient_uid
            }
            // 翻译title_cn
            let ts = new Date().getTime();
            let secret = "4ede4aafbzd51cbz3e32bzb781bzee9813d17154";
            let clientId = "zeta";
            let tokenStr = `${clientId}.bz${ts}.bz${pmid}.bz${secret}`;
            let token = md5(tokenStr, 32);
            const params2 = {
              client_id: clientId,
              ts: Number(ts),
              pmid: String(pmid),
              types: "cn_key",
              token: token,
            };
            const [result1, result2] = await Promise.all([caseTranslate(params1), translateInfo(params2)]).catch(res => {
              currentData[index1].loading = false;
            });
            currentData[index1].loading = false;
            if(result1 && result1.data && result1.data.status == 0) {
              const { patient_cn } = result1.data.data;
              currentData[index1].patient_cn = patient_cn;
            }
            if(result2 && result2.data && result2.data.status == 0) {
              const { title } = result2.data.data;
              currentData[index1].title_cn = title;
            }
            currentData[index1].translate = true
          }
        }

        this.caseTimeData = Object.assign({}, this.caseTimeData);
      },
      // 展开全文
      showFull(key_height, index, index1) {
        if (key_height === "initHeight") {
          this.caseTimeData[index][index1]["key_height"] = "autoHeight";
        } else {
          this.caseTimeData[index][index1]["key_height"] = "initHeight";
        }
        this.caseTimeData = Object.assign({}, this.caseTimeData)
      },
      // 查看源文献
      showFullText(data) {
        let Logger = webTrackerEvent();
        Logger.push("eventType", "caseReportItem_click");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("pmid", data.pmid);
        Logger.push("pageUrl", window.location.href);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        const { href } = this.$router.resolve({
          name: "fullText",
          path: "/fullText",
          query: {
            pmid: data.pmid
          },
        });
        window.open(href);
      },
      // 查看全文
      showCaseDetail(data) {
        let Logger = webTrackerEvent();
        Logger.push("eventType", "caseReportItem_viewDetail");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("patientUid", data.patient_uid);
        Logger.push("pmid", data.pmid);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.push("pageUrl", window.location.href);
        Logger.logger();
        const { href } = this.$router.resolve({
          name: "caseDetail",
          path: "/caseDetail",
          query: {
            patientUid: data.patient_uid,
            pmid: data.pmid,
            searchType: 'patient'
          },
        });
        window.open(href);
        // this.$router.push("fullText?pmid=" + pmid);
      },
      // 获取病例信息
      async getCollection() {
        let params = {
          page: this.pageNum,
          limit: this.pageSize
        }
        let res = await caseCollect("GET", params);
        if (res && res.data.status == 0) {
          this.totalNum = res.data.count;
          this.isShow = true;
          this.caseTimeData = {};
          if (res.data.data.length === 0) {
            this.$emit('hideOrShowCase', false)
            return;
          }
          res.data.data.forEach((item) => {
            const collect_date = item.collect_time.substring(0, 10);
            this.caseTimeData[collect_date] = [];
          });
          res.data.data.forEach((item, index) => {
            const collect_date = item.collect_time.substring(0, 10);
            item.patient_en = item.patient_en.replace(/\n/g, '<br/>');
            // item.patient_cn = item.patient_cn.replace(/\n/g, '<br/>');
            item.patient_cn = "";
            item.key_height = "initHeight";
            item.translate = false;
            item.loading = false;
            if (item.gender) {
              item.avatar = require('../../assets/img/female.png')
            } else {
              item.avatar = require('../../assets/img/male.png')
            }
            if (this.caseTimeData[collect_date]) {
              this.caseTimeData[collect_date].push(item)
            }
          })
        } else {
          this.$emit('hideOrShowCase', false)
          this.caseTimeData = {};
          this.isShow = false;
        }
      },
      // 取消收藏
      collection(data, index, index1) {
        let Logger = webTrackerEvent();
        Logger.push("eventType", "cancel_collection_case");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("patientUid", data.patient_uid);
        Logger.push("pageUrl", window.location.href);
        Logger.push("pmid", data.pmid);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        caseCollect("DELETE", { patient_uid: data.patient_uid }).then((res) => {
          if (res.data.status === 0) {
            // this.caseTimeData[index].splice(index1, 1);
            // this.caseTimeData = Object.assign({}, this.caseTimeData)
            this.pageNum = 1;
            this.caseTimeData = {};
            this.getCollection()
          } else {
            this.$message({
              message: "取消失败，请重试",
              type: "error",
            })
          }
        })
      },
      // 查看相似病例
      showSimilarCase(data) {
        let Logger = webTrackerEvent();
        Logger.push("eventType", "viewSimilarCase");
        Logger.push("timeStamp", new Date().getTime());
        Logger.push("pmid", data.pmid);
        Logger.push("patient_uid", data.patient_uid);
        Logger.push("pageUrl", window.location.href);
        Logger.push("token", this.token);
        Logger.push("openid", this.openid);
        Logger.logger();
        const { href } = this.$router.resolve({
          name: "similarCase",
          path: "/similarCase",
          query: {
            pmid: data.pmid,
            patientUid: data.patient_uid
          },
        });
        window.open(href);
      }
    },
    created() {
      this.getCollection();
    }
  }
</script>

<style scoped lang="less">
  .collectionBox{
    .caseList{
      width: 1000px;
      margin: 0 auto;
      margin-top: 20px;
    }
    .timeLine{
      font-size: 14px;
      color: #4586d5;
      padding-left: 24px;
      background: url("../../assets/img/collection2.png") no-repeat 0 center;
      margin-bottom: 10px;
    }
  }
  /deep/.el-timeline-item__tail {
    left: -16px;
    height: 100% !important;
    border: 1px dashed #ebebeb;
  }
  .collectionBox .caseList ul li {
    // border-bottom: 1px solid #ccc;
    // padding: 10px;
    position: relative;
    // overflow: hidden;
    h3{
      display: flex;
      justify-content: space-between;
      font-weight: normal;
      // align-items: center;
      span{
        font-size: 16px;
        color: #333;
        font-weight: 700;
        max-width: 80%;
        // word-break: break-all;
      }
      img{
        width: 20px;
        height: 20px;
      }
      em{
        // flex: 1;
        text-align: right;
        margin-right: 60px;
        font-size: 14px;
        display: flex;
        align-items: center;
        img{
          width: 17px;
          height: 17px;
          margin-right: 10px;
        }
      }
    }
    .important-message{
      font-size: 14px;
      margin: 10px 0;
      color: #333;
      display: flex;
      span{
        em{
          color: #387ed2;
        }
        margin-right: 40px;
        &.qikan{
          width: 60%;
        }
      }
    }
    .userInfo{
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #333;
      margin-bottom: 10px;
      .info-box{
        display: flex;
        flex-direction: column;
        margin-left: 10px;
        .pat-code{
          color: #387ed2;
        }
        .gender{
          margin-top: 10px;
        }
      }
    }
    .listInfo{
      p.info-detail{
        font-size: 14px;
        color: #333;
        margin-bottom: 10px;
        line-height: 22px;
        span{
          color: #387ed2;
        }
        &.initHeight{
          overflow: hidden;
          /*将对象作为弹性伸缩盒子模型显示*/
          display: -webkit-box;
          /*设置子元素排列方式*/
          -webkit-box-orient: vertical;
          /*设置显示的行数，多出的部分会显示为...*/
          -webkit-line-clamp: 3;
        }
        &.autoHeight{
          display: block;
        }
      }
      .down{
        font-size: 24px;
        cursor: pointer;
        display: flex;
        justify-content: flex-end;
      }
    }
    .actionBox{
      display: flex;
      align-items: center;
      a{
        display: flex;
        align-items: center;
        margin-right: 40px;
        img{
          margin-right: 8px;
          width: 30px;
        }
      }
    }
    &.infoLi{
      border: 1px solid #ccc;
      margin-top: -1px;
      padding: 10px;
    }
  }
  .collectionBox {
    .el-pagination {
      margin-top: 30px;
      text-align: center;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/case/collection.vue